import { isAndroid } from "@microdoing/shared/utils/deviceDetectors";

const url = "https://api.microdoing.com";
// const url = isAndroid ? "http://10.0.2.2" : "http://localhost";
// const url = "https://microdoing-api.eu.ngrok.io";

// if (ENV_TYPE === 'production') {
//   url = 'https://api.pulse-experience.co';
// } else if (ENV_TYPE === 'local') {
//   url = 'http://localhost';
// }
export default {
  clientId: "8puWuJWZYls1Ylawxm6CMiYREhsGGSyw",
  url,
};
